module.exports = __webpack_public_path__ + "img/logo.2ba27f63.svg";